import React, { useEffect, useState } from 'react';
import { Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { entityInfoService } from '../../../../entity-management';
import { SelfBillingPayment } from '../../entity-profile/SelfBillingPayment/SelfBillingPayment';
import { AutomatedBillingPayment } from '../../entity-profile/AutomatedBillingPayment/AutomatedBillingPayment';

const NgzNutritionSubscriptionPage = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();
  const { billingType } = loggedInUserDataStore;
  const entityType = loggedInUserDataStore.loggedInUser?.entityType;

  const [isStripeConnected, setIsStripeConnected] = useState(false);

  useEffect(() => {
    entityInfoService.getEntityAdminInfo().then((info) => {
      setIsStripeConnected(info.isStripeAccountConnected);
    });
  }, [entityId]);

  if (!entityType) {
    return null;
  }

  return (
    <Container>
      {billingType.SELF_BILLING && (
        <SelfBillingPayment entityId={entityId} entityType={entityType} />
      )}
      {billingType.AUTOMATED_BILLING && (
        <AutomatedBillingPayment
          entityId={entityId}
          isStripeConnected={isStripeConnected}
          entityType={entityType}
        />
      )}
    </Container>
  );
});

angularizeWithProviders(NgzNutritionSubscriptionPage, 'ngzNutritionSubscriptionPage', {});

export { NgzNutritionSubscriptionPage };
